import React, { useEffect, useState } from "react";
import { offers } from "../data/offers";
import Container from "../../../../../utils/Container";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { getAllFeaturedOffers } from "../../../../../api/website/home/homeApi";

const Offers = () => {
  const [Offers, setOffers] = useState([]);
  useEffect(() => {
    getAllFeaturedOffers(setOffers);
  }, []);
  return (
    <>
      {Offers.length > 0 && (
        <Container>
          <div className="w-full space-y-3">
            <div>
              <h2 className="py-2 font-bold text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Offers are waiting for you!
              </h2>
            </div>
            <div>
              <Swiper
                className="w-full h-auto"
                slidesPerView={4}
                spaceBetween={30}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  520: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
              >
                {Offers.map((item, index) => {
                  return (
                    <SwiperSlide
                      key={index}
                      className="rounded-lg overflow-hidden shadow-lg border border-[#cbddfd] cursor-pointer bg-white"
                    >
                      <Link
                        to={`/offer/${item.id}/${encodeURIComponent(
                          item.offerTitle
                        )}`}
                      >
                        <div>
                          <div className="w-full h-[200px] rounded-lg overflow-hidden">
                            <img
                              className="w-full h-full object-cover"
                              src={item.featuredImage}
                              alt={item.offerTitle}
                            />
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

export default Offers;
